import { render, staticRenderFns } from "./DepartmentModal.vue?vue&type=template&id=31d9b66a&"
import script from "./DepartmentModal.vue?vue&type=script&lang=ts&"
export * from "./DepartmentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports